import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { Partner } from '../../../../../../partners';

import './index.scss';

interface Props {
  isActive?: boolean;
  partner: Partner;
}

const b = b_.with('main-page-partners-slider-slide');

const Slide: React.FC<Props> = ({ isActive, partner }) => {
  const { t } = useTranslation();

  return (
    <div className={b({ 'animation-in': isActive, 'animation-out': !isActive })}>
      <img className={b('img')} src={partner.imgBig} alt={partner.name} />
      <div className={b('wrapper')}>
        <div className={b('name')}>{partner.name}</div>
        <div className={b('position')}>{partner.positionInCompany}</div>
        <div className={b('info-list')}>
          {(partner.info || []).map((item, index) => (
            <div key={index} className={b('info-item')}>
              {item}
            </div>
          ))}
        </div>
        {partner.channelLink && (
          <a href={partner.channelLink} className={b('followers')} target="_blank" rel="noopener">
            {partner.followers} <div className={b('followers-img')}></div>{' '}
            <div>{t('on {{channel}}', { channel: partner.channel })}</div>
          </a>
        )}
      </div>
    </div>
  );
};

export default Slide;
